import type { TDealsBoard } from '../model';
import type { TDeal } from '@crm/entities/deal';

export const updateDealInBoard = (
    dealsBoard: TDealsBoard | undefined,
    dealId: TDeal['id'],
    dealPatch: Partial<TDeal>
) => {
    if (!dealsBoard) {
        return dealsBoard;
    }

    return {
        ...dealsBoard,
        columns: dealsBoard.columns.map((column) => ({
            ...column,
            deals: column.deals.map((deal) =>
                deal.id === dealId ? { ...deal, ...dealPatch } : deal
            ),
        })),
    };
};
